import React, { useContext, useState } from 'react'
import DocumentsContext from 'app/react/components/documents/DocumentsContext'
import classNames from 'classnames'

export default function Sidebar () {

  const [activeCat, setActiveCat] = useState(0)
  const { categories, setCurrentCategories, setPage } = useContext(DocumentsContext)

  if (categories.length === 0) {
    return null
  }

  const handleCategoryChange = (i) => {
    setActiveCat(i)
    setCurrentCategories(categories[i].termId)
    setPage(1)
  }

  return (
    <div className="dm-documents-sidebar">
      <div className="dm-documents-sidebar__title">Kategorier</div>
      <div className="dm-documents-sidebar__categories">
        {categories.map((cat, i) => {
          return (
            <div key={i} className={classNames('dm-documents-sidebar__category', {
              'dm-documents-sidebar__category--active': activeCat === i
            })} onClick={() => handleCategoryChange(i)}>{cat.name}</div>
          )
        })}
      </div>
      <div className="dm-documents-sidebar__categories-select select-container">
        <label>Vælg kategori</label>
        <select value={activeCat} className="dm-select dm-select--lightgrey" onChange={(e) => handleCategoryChange(e.target.selectedIndex)}>
          {categories.map((cat, i) => {
            return (
              <option key={i} value={i}>{cat.name}</option>
            )
          })}
        </select>
      </div>
    </div>
  )
}